import React from "react";
import styles from "./styles.module.css";
import { ButtonProps } from "../types";
import { TextSubtitle2 } from "fonts/Subtitle2";
import { Spacing } from "spacing/component";

export const Button2 = ({
  text,
  disabled,
  onClick,
  className
}: ButtonProps) => (
  <button
    className={styles.component + (className ? ` ${className}` : "")}
    {...{ disabled, onClick }}
  >
    <Spacing ph="l" pv="xs">
      <TextSubtitle2 centered>{text}</TextSubtitle2>
    </Spacing>
  </button>
);
